module.exports = __webpack_public_path__ + "static/media/ESS_hose.88701943.jpg";